export const getAPIURL = (originalOrigin) => {
  // Split the original origin into its components
  const url = new URL(originalOrigin || window.location.origin);

  // Remove "www" prefix if it exists
  // if (url.hostname.startsWith("www.")) {
  //   url.hostname = url.hostname.slice(4); // Remove the "www."
  // }

  // // Check if the URL starts with "local." and return it as-is
  if (url.hostname.startsWith("dev") || url.hostname.startsWith("local")) {
    // Append "api" as a subdomain
    return `https://gcp-api.dev.roemanu.io`;
  }
  if (url.hostname.startsWith("qa")) {
    // Append "api" as a subdomain
    return `https://gcp-api.qa.roemanu.io`;
  }
  if (url.hostname.startsWith("uat")) {
    // Append "api" as a subdomain
    return `https://gcp-api.uat.roemanu.io`;
  }
  else {
    // Append "api" as a subdomain
    return `https://gcp-api.prod.roemanu.io`;
  }

  // Reconstruct and return the new origin
  return url.origin;
};
